import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/** Updates the select from section HTML when the variant changes (variant list metafield). */
class ProductMetafieldLineItemSelect extends HTMLElement {
  #section = /** @type {Element | null} */ (null);

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newEl = event.detail.data.html.querySelector(
      `product-metafield-line-item-select[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newEl) return;

    morph(this, newEl, { childrenOnly: true });
    this.toggleAttribute('hidden', newEl.hasAttribute('hidden'));
  };
}

if (!customElements.get('product-metafield-line-item-select')) {
  customElements.define('product-metafield-line-item-select', ProductMetafieldLineItemSelect);
}
